import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useAuthUser, useQuery } from '..';

interface UseCampaignsProps {
  currentPage?: number;
}

export function useCampaigns({ currentPage = 0 }: UseCampaignsProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();
  const user = useAuthUser();

  const queryKey = `client-campaigns-search-${currentPage}`;
  const teamId = user?.team?.team_id;

  const {
    data = {},
    error,
    isLoading
  } = useQuery({
    queryKey,
    queryData: teamId,
    queryFn: async () => {
      return getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/client/campaigns/search?page_number=${currentPage}&page_size=${10}`,
        token
      }).then(
        (
          response: {
            page_number: number;
            page_size: number;
            count_total: number;
            has_more: true;
            campaigns: Api.Client.Campaign[];
          } & ResponseObject
        ) => {
          if ((response as ResponseExpiredToken).isExpired) {
            logout();
          }

          if ('code' in response) {
            setAlert(response.code);
          }

          return {
            campaigns: response.campaigns,
            pageNumber: response.page_number,
            pageSize: response.page_size,
            countTotal: response.count_total,
            hasMore: response.has_more
          };
        }
      );
    },
    enabled: !!token && !!teamId
  });

  return {
    isLoading,
    error,
    data
  };
}
